export default {
  transactions(state) {
    return state.transactions;
  },
};
